import type { SyntheticEvent } from 'react';

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';

import { ResolverList } from './ResolverList';
import type { OnSelectHandler } from './ResolverList/types/on-select-handler.type';
import type { ResolversSettings } from './ResolverList/types/resolvers-settings.type';

export interface Props {
  readonly isOpen: boolean;
  readonly onClose: (event: Readonly<SyntheticEvent>) => void;
  readonly onSelect?: OnSelectHandler;
  readonly resolversSettings: ResolversSettings;
}

export const ResolverSelectionDialog = ({
  isOpen,
  onClose: handleClose,
  onSelect: handleSelect,
  resolversSettings,
}: Readonly<Props>) => (
  <Dialog fullWidth maxWidth="md" onClose={handleClose} open={isOpen}>
    <DialogTitle>Liste des résolveurs</DialogTitle>
    <DialogContent>
      <DialogContentText sx={{ mb: 4 }}>
        Vous pouvez utiliser les résolveurs suivants dans les sections de vos
        documents ou bien dans les zones de saisies de vos formulaires. Vous
        pouvez décider d&apos;insérer un code qui sera uniquement résolu lors de
        la génération du document ou du formulaire, ou bien vous pouvez décider
        de générer immédiatement le contenu de ce résolveur.
      </DialogContentText>
      <ResolverList
        onSelect={handleSelect}
        resolversSettings={resolversSettings}
      />
    </DialogContent>
    <DialogActions sx={{ px: 2, pb: 2 }}>
      <Button onClick={handleClose} size="large" variant="outlined">
        Fermer
      </Button>
    </DialogActions>
  </Dialog>
);
